import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'

export default {
  name: 'swipe',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      sidebar_tab: '9',
      list: [],
      loading: true,
      theme: [],
      category: [
        {
          name: '会社情報',
          icon: ['fas', 'building'],
          description: ''
        },
        {
          name: '社員情報',
          icon: ['fas', 'portrait'],
          description: ''
        },
        {
          name: '職場情報',
          icon: ['fas', 'map-marker-alt'],
          description: ''
        },
        {
          name: '新卒採用情報',
          icon: ['fas', 'user-tie'],
          description: ''
        },
        {
          name: 'インターン採用情報',
          icon: ['fas', 'school'],
          description: ''
        },
        {
          name: 'イベント情報',
          icon: ['fas', 'bullhorn'],
          description: ''
        },
        {
          name: 'リリース情報',
          icon: ['fas', 'info-circle'],
          description: ''
        },
        {
          name: '記事情報',
          icon: ['fas', 'rss-square'],
          description: ''
        },
        {
          name: 'アルバイト採用情報',
          icon: ['fas', 'coffee'],
          description: ''
        }
      ],
      isModal: false,
      modalInfo: {},
      updating: false,
      view: 1,
      fields: [
        {key: 'title', label: 'タイトル', sortable: false, tdClass: 'title text-left align-middle'},
        {key: 'status', label: 'ステータス', sortable: false, tdClass: 'align-middle text-center'},
        {key: 'swipe', label: 'スワイプ', sortable: false, tdClass: 'align-middle'},
        {key: 'action', label: 'アクション', sortable: false, tdClass: 'align-middle'}
      ],
      publish: [],
      draft: [],
      done: [],
      stop: [],
      key: 'draft'
    }
  },
  mounted () {
    this.loading = true
    this.fetchData()
  },
  methods: {
    fetchData () {
      let pathParams = {
        swipeId: 'list'
      }

      let additionalParams = {
        queryParams: {
          type: 'list'
        }
      }

      this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.list = response.data.draft
          this.publish = response.data.publish
          this.draft = response.data.draft
          this.done = response.data.done
          this.stop = response.data.stop
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCover (coverStatus, id) {
      if (!coverStatus) {
        return id
      } else if (coverStatus === 1) {
        return `${this.env.S3}/enterprise/swipe/${id}.png`
      }
    },
    openModal (item) {
      this.modalInfo = item
      this.isModal = true
    },
    update () {
      this.updating = true

      let pathParams = {
        swipeId: this.modalInfo.swipeId
      }

      let additionalParams = {
        queryParams: {
          type: this.modalInfo.status === 2 ? 'undo' : this.modalInfo.status === 3 ? 'stop' : 'delete',
          planId: this.user.planId
        }
      }

      this.$apig.patch(this.$store.getters.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.fetchData()
          this.updating = false
          this.isModal = false
        })
        .catch(err => {
          // 失敗のアラート
          console.log(err)
          this.updating = false
        })
    },
    copy (item) {
      item.copying = true

      let pathParams = {
        swipeId: item.swipeId
      }

      let additionalParams = {
        queryParams: {
          type: 'copy'
        }
      }

      this.$apig.patch(this.$store.getters.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.$router.push({path: `/swipe/edit?id=${response.data.swipeId}`})
        })
        .catch(err => {
          // 失敗のアラート
          console.log(err)
          item.copying = false
        })
    },
    setStatus (key) {
      this.key = key
      this.list = this[key]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/swipe/swipe.js